//hooks
import useRestoreContentFromPage from './useRestoreContentFromPage.hook'

// component lib
import { BasicButton, LoadingSpinner } from "thrive-components";
import Toast, { ToastMessageType } from "@/components/elements/global/ToastNotification";

// styles
import  '@/css/restoreContentButton.scss';


const RestoreContentWrapper = ({contentId, appId}: {contentId:string, appId: string}) => {
   
    const {
        showToast,
        toastVariables,
        isLoading,
        restore,
        handleToastMessageClose
    } = useRestoreContentFromPage({contentId, appId})

    return <>
        <Toast
            show={showToast}
            closeToast={handleToastMessageClose} 
            messageType={toastVariables?.messageType as ToastMessageType}
        > 
            {toastVariables?.message}
        </Toast>
        
        <BasicButton 
            content={isLoading ? <LoadingSpinner size={8}/> : "Restore"}
            ariaLabel={isLoading ? "Restoring Content please wait" :"Restore Content"}
            onButtonClick={restore}
            isDisabled={isLoading}
        />
    </>
}

export default RestoreContentWrapper